import { Injectable, OnDestroy } from '@angular/core';

import { GenerateUUID } from '@empathy/global/utils';
import { PreviewMediaStoreContract } from '@empathy/survey-viewer';

@Injectable()
export class PreviewMediaStore implements PreviewMediaStoreContract, OnDestroy {
  static readonly PREFIX = 'preview-media:';

  private readonly urls = new Map<string, string>();

  add(file: File): string {
    const id = `${PreviewMediaStore.PREFIX}${GenerateUUID()}`;
    this.urls.set(id, URL.createObjectURL(file));
    return id;
  }

  has(id: string): boolean {
    return this.urls.has(id);
  }

  urlFor(id: string): string | null {
    return this.urls.get(id) ?? null;
  }

  remove(id: string): void {
    const url = this.urls.get(id);
    if (url) {
      URL.revokeObjectURL(url);
    }
    this.urls.delete(id);
  }

  reconcile(retainedIds: ReadonlySet<string>): void {
    [...this.urls.keys()].filter((id) => !retainedIds.has(id)).forEach((id) => this.remove(id));
  }

  ngOnDestroy(): void {
    this.urls.forEach((url) => URL.revokeObjectURL(url));
    this.urls.clear();
  }
}
